export const authFieldClassName =
  'h-12 rounded-[6px] border-border-strong bg-white px-3.5 text-xs text-brand-secondary-dark placeholder:text-brand-secondary-dark/40 shadow-none focus-visible:border-brand-secondary-dark focus-visible:ring-0 dark:bg-card dark:text-foreground dark:placeholder:text-muted-foreground';

export const authPasswordFieldClassName =
  'tracking-[0.12em] focus-visible:border-brand-primary focus-visible:shadow-[0_0_0_4px_rgb(191_191_191_/_0.2)]';

export const authLabelClassName =
  'font-label text-brand-secondary-dark uppercase dark:text-foreground';

export const authLinkClassName =
  'font-label text-brand-primary uppercase hover:text-brand-primary-dark';

export const authSubtitleClassName =
  'text-xs leading-[21px] text-brand-secondary dark:text-muted-foreground';

export const authTitleClassName =
  'text-[40px] leading-[0.945] tracking-[-0.05em] text-brand-secondary-dark dark:text-foreground';

export const authFormShellClassName = 'flex w-full flex-col py-4 lg:pt-10';

export const authFormNarrowClassName = 'mx-auto max-w-[330px]';

export const authFormClassName = 'flex flex-col gap-[22px]';

export const authSubmitButtonClassName = 'w-full rounded-[6px]';

export const authFooterTextClassName =
  'font-sans text-xs leading-[21px] text-brand-secondary dark:text-muted-foreground';

export const authColumnHeightClassName = '';
